/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForSaasGcpServiceAccountProtocol extends models.ServiceAccountCredentialsBaseForSaasGcp {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForSaasGcpServiceAccountProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForSaasGcpServiceAccountProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForSaasGcpServiceAccountProtocol>): ServiceAccountCredentialsForSaasGcpServiceAccountProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForSaasGcpServiceAccountProtocol(), model);
        ServiceAccountCredentialsForSaasGcpServiceAccountProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForSaasGcpServiceAccountProtocol>): ServiceAccountCredentialsForSaasGcpServiceAccountProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForSaasGcpServiceAccountProtocol.newInstance(<ServiceAccountCredentialsForSaasGcpServiceAccountProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForSaasGcpServiceAccountProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForSaasGcpServiceAccountProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForSaasGcpServiceAccountProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForSaasGcp.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForSaasGcpServiceAccountProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Project Id in which the bucket exists. This is a required field.
     */
    project_id: string;

    /**
     * Client Email.  This is a required field.
     */
    client_email: string;

    /**
     * Client Id. This is a required field.
     */
    client_id: string;

    /**
     * Private Key. This is a required field.
     */
    private_key: string;

    /**
     * Private Key Id. This is a required field.
     */
    private_key_id: string;

}
